export default defineNuxtPlugin((nuxtApp) => {
  const buildUrl = function (tsid, sku) {
    return `https://cdn1.api.trustedshops.com/shops/${tsid}/products/skus/${this.toHex(
      sku
    )}/productreviewstickers/v1/reviews.json`;
  };

  const toHex = function (str) {
    let hex = null;
    try {
      hex = unescape(encodeURIComponent(str))
        .split('')
        .map((v) => v.charCodeAt(0).toString(16))
        .join('');
    } catch (e) {
      console.error('invalid text input: ' + str);
    }
    return hex;
  };

  const fetchReviews = function (sku) {
    const { $i18n } = nuxtApp;
    const locale = $i18n.locale.value;
    const locales = $i18n.locales.value;
    const tsid = locales.find((l) => l.code === locale)?.tsid;

    if (tsid && sku) {
      const tsUrl = this.buildUrl(tsid, sku);
      return $fetch(tsUrl, {
        timeout: 1500,
      })
        .then((res) => {
          try {
            return res.response.data.product;
          } catch (e) {
            return null;
          }
        })
        .catch(() => {
          console.warn('no reviews found for ' + sku);
          return null;
        });
    }
  };

  return {
    provide: {
      productReviews: {
        toHex,
        buildUrl,
        fetchReviews,
      },
    },
  };
});
